<template>
  <div class="columns">
    <div class="column is-narrow">
      <b-button
        class="ws-button"
        :class="{'is-info': expertType === expertTypes.expert}"
        type="button"
        @click="changeType(expertTypes.expert)"
        outlined
      >Эксперты</b-button>
    </div>
    <div class="column is-narrow">
      <b-button
        v-if="isDisableCheckDocs"
        class="ws-button"
        :class="{'is-info': expertType === expertTypes.user}"
        type="button"
        @click="changeType(expertTypes.user)"
        outlined
      >Пользователи</b-button>
    </div>
  </div>
</template>

<script>
import expertTypes from '../../demo-exams/data/expertTypesEnum'

export default {
  name: 'ws-experts-types-buttons',
  props: {
    expertType: {
      type: String,
      required: true
    },
    isDisableCheckDocs: {
      type: Boolean,
      default: true
    },
    changeType: {
      type: Function,
      default: () => {}
    }
  },
  data: () => ({
    expertTypes
  })
}
</script>
